import akouoLogo from 'FEATURES/interpreter/resources/images/akouo-logo-grey.svg';
import './Header.scss';

const AkouoLogoGrey = () => {
  return <img src={akouoLogo} alt="Akouo Logo" />;
};

export default AkouoLogoGrey;
